import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiBaseUrl } from "network";

export const staffSlice = createApi({
    reducerPath: "staffSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getStaff: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/backend/v1/auth/staff?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Location
        addStaff: builder.mutation({
            query: (body) => ({
                url: "/backend/v1/auth/staffAdd",
                method: "POST",
                body,
            }),
        }),

        getOneStaff: builder.query({
            query: (id) => ({
                url: `/backend/v1/auth/staff/${id}`,
                method: "GET",

            }),
        }),

        // ✅ Update Existing Category
        updateStaff: builder.mutation({
            query: ({ id, body }) => ({
                url: `/backend/v1/auth/staff/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteStaff: builder.mutation({
            query: (id) => ({
                url: `/backend/v1/auth/staff/${id}`,
                method: "DELETE",
            }),
        }),
        getAllUser: builder.mutation({
            query: ({ type }) => ({
                url: `/backend/v1/auth/get-user`,
                method: "POST",
                body: { type }
            })
        })
        ,
        sendNotification: builder.mutation({
            query: ({ type, title, description, userIds }) => ({
                url: `/backend/v1/auth/send-notifications`,
                method: "POST",
                body: { type, title, description, userIds }
            })
        })



    }),
});

export const {
    useGetStaffQuery,
    useAddStaffMutation,
    useGetOneStaffQuery,
    useUpdateStaffMutation,
    useDeleteStaffMutation,
    useGetAllUserMutation,
    useSendNotificationMutation
} = staffSlice;